module.exports = __webpack_public_path__ + "static/media/download-apps-stock.d0c5d285.webp";